window.custom_theme = window.custom_theme || {};
  document.addEventListener('DOMContentLoaded', function () {
    custom_theme.initSoldOutSort();
    
    // Listen for sorting changes
    custom_theme.listenForSortingChanges();
  });
  
  let isLoading = false;
  let soldOutItems = [];
  let observer = null;
  let allProductsLoaded = false;
  
  custom_theme.listenForSortingChanges = function() {
    // Listen for sort selection changes
    const sortLinks = document.querySelectorAll('[data-sort-link]');
    if (sortLinks.length) {
      sortLinks.forEach(link => {
        link.addEventListener('click', function() {
          // Reset sold out items when sorting changes
          soldOutItems = [];
          allProductsLoaded = false;
          
          // Re-initialize after the AJAX completes (give it time to load)
          setTimeout(function() {
            custom_theme.initSoldOutSort();
          }, 1000); // Adjust timeout if needed
        });
      });
    }
    
    // Also watch for form submissions on sort form
    const sortForm = document.querySelector('form[data-collection-filters-form]');
    if (sortForm) {
      sortForm.addEventListener('submit', function() {
        soldOutItems = [];
        allProductsLoaded = false;
      });
    }
  };
  
  custom_theme.initSoldOutSort = function () {
    if (allProductsLoaded) return;
  
    const productsContainer = document.querySelector('#CollectionLoop');
    if (!productsContainer) return;
  
    custom_theme.extractAndRemoveSoldOut(productsContainer);
  
    if (observer) observer.disconnect();
    observer = new MutationObserver((mutations) => {
      if (!allProductsLoaded) {
        // Check if this is a sorting/filtering change
        let isSortingChange = false;
        mutations.forEach(mutation => {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 5) {
            isSortingChange = true;
          }
        });
        
        if (isSortingChange) {
          // Major DOM change detected, likely a sort/filter operation
          soldOutItems = []; // Reset sold out items
          allProductsLoaded = false;
        }
        
        const container = document.querySelector('#CollectionLoop');
        if (container) {
          custom_theme.extractAndRemoveSoldOut(container);
        }
      }
    });
  
    observer.observe(productsContainer.parentNode, {
      childList: true,
      subtree: true
    });
  };
  
  custom_theme.extractAndRemoveSoldOut = function (container) {
    if (!container) return;
    const nextUrl = container.dataset.nextUrl;
    console.log('nextUrl ert',nextUrl)
    // if (!nextUrl) {
    //   return;
    // };
  
    const existingSoldOut = container.querySelectorAll('.grid-item.product-item--has-soldout');
  
    existingSoldOut.forEach(item => {
      const id = item.getAttribute('id');
      const alreadyStored = soldOutItems.find(stored => stored.getAttribute('id') === id);
  
      if (!alreadyStored) {
        soldOutItems.push(item.cloneNode(true));
      }
  
      item.remove();
    });
     if (!nextUrl) {
        // Disconnect observer to prevent infinite loop
        if (observer) observer.disconnect();

        // Remove any existing sold-out items from DOM (in case of re-filtering)
        const existingInDom = container.querySelectorAll('.product-item--has-soldout');
        existingInDom.forEach(item => item.remove());

        // Append all collected sold-out items at the end, avoiding duplicates
        const usedIds = new Set();
        soldOutItems.forEach(item => {
        const id = item.getAttribute('id');
        if (id && !usedIds.has(id)) {
            item.style.display = "flex";
            container.appendChild(item);
            usedIds.add(id);
        }
        });
    }
  };
  
  custom_theme.loadMoreProducts = function () {
    if (isLoading) return;
  
    const productsContainer = document.querySelector('#CollectionLoop');
    const loadMoreBtn = document.querySelector('.load-more_btn');
  
    if (!productsContainer || !loadMoreBtn) return;
  
    const nextUrl = productsContainer.dataset.nextUrl;
    if (!nextUrl) return;
  
    isLoading = true;
    loadMoreBtn.textContent = 'Loading...';
  
    fetch(nextUrl)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProductsContainer = doc.querySelector('#CollectionLoop');
  
        if (!newProductsContainer) return;
  
        // Add new sold-out products to the array
        const newSoldOut = newProductsContainer.querySelectorAll('.grid-item.product-item--has-soldout');
        newSoldOut.forEach(item => {
          const id = item.getAttribute('id');
          if (id && !soldOutItems.find(stored => stored.getAttribute('id') === id)) {
            soldOutItems.push(item.cloneNode(true));
          }
        });
  
        // Append only available items
        const availableProducts = newProductsContainer.querySelectorAll('.grid-item.product-item:not(.product-item--has-soldout)');
        availableProducts.forEach(item => productsContainer.appendChild(item));
  
        const updatedNextUrl = newProductsContainer.dataset.nextUrl;
        if (updatedNextUrl) {
          productsContainer.dataset.nextUrl = updatedNextUrl;
          loadMoreBtn.textContent = 'Load more';
        } else {
          loadMoreBtn.style.display = 'none';
          allProductsLoaded = true;
  
          if (observer) observer.disconnect();
  
          // Remove any existing sold-out items from DOM
          const existingSoldOut = productsContainer.querySelectorAll('.product-item--has-soldout');
          existingSoldOut.forEach(item => item.remove());
  
          // Append all collected sold-out items
          const usedIds = new Set();
          soldOutItems.forEach(item => {
            const id = item.getAttribute('id');
            if (id && !usedIds.has(id)) {
              item.style.display = "flex"; 
              productsContainer.appendChild(item);
              usedIds.add(id);
              // Remove is-loading from images/wrappers
                const imgs = item.querySelectorAll('img');
                imgs.forEach(img => {
                  const removeIsLoading = () => {
                    if (img.classList.contains('is-loading')) img.classList.remove('is-loading');
                    if (img.parentElement && img.parentElement.classList.contains('is-loading')) img.parentElement.classList.remove('is-loading');
                  };
                  if (img.complete) {
                    removeIsLoading();
                  } else {
                    img.addEventListener('load', removeIsLoading, { once: true });
                  }
                });
              // --- Remove blank flickity-viewport elements ---
              const viewports = item.querySelectorAll('.flickity-viewport');
              if (viewports.length > 1) {
                viewports.forEach(vp => {
                  const slider = vp.querySelector('.flickity-slider');
                  if (!slider || !slider.children.length) {
                    vp.remove();
                  }
                });
              }
            }
          });
        }
      })
      .catch(err => {
        console.error('Error fetching more products:', err);
      })
      .finally(() => {
        isLoading = false;
      });
  };
  
  // Handle Load More button click
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.load-more_btn');
    if (btn) {
      e.preventDefault();
      custom_theme.loadMoreProducts();
    }
  });
  
  // Create a global function to update when sorting changes
  document.addEventListener('sort:updated', function() {
    soldOutItems = [];
    allProductsLoaded = false;
    setTimeout(function() {
      custom_theme.initSoldOutSort();
    }, 500);
  });
  document.addEventListener('click', function (e) {
    const filter_input  = e.target.closest('.filter-group input');
    const filter_select  = e.target.closest('.filter-group select');
    const active_filter = e.target.closest('.collection__active__filters .active__filters__remove');
    if (filter_input || filter_select || active_filter ) {
        console.log("filter")
      setTimeout(function() {
        custom_theme.initSoldOutSort();
        }, 500);
    }
});
// Dedicated MutationObserver to handle post-filtering sold-out sorting
(function() {
  let filterObserver = null;
  let debounceTimer = null;

  function observeProductGrid() {
    const productsContainer = document.querySelector('#CollectionLoop');
    if (!productsContainer) return;

    if (filterObserver) filterObserver.disconnect();

    filterObserver = new MutationObserver((mutationsList) => {
      // Debounce: wait 100ms after the last DOM change before running logic
      if (debounceTimer) clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        // Always extract and remove sold-out products
       const nextUrl = productsContainer.dataset.nextUrl;
       console.log("extt",nextUrl)
        if (!nextUrl) {
        custom_theme.extractAndRemoveSoldOut(productsContainer);
        } else {
        custom_theme.initSoldOutSort();
        }
      }, 100);
    });

    filterObserver.observe(productsContainer, {
      childList: true,
      subtree: false
    });
  }
   document.addEventListener('DOMContentLoaded', function() {
    observeProductGrid();
    // observeGridParent();
  });
  document.addEventListener('sort:updated', observeProductGrid);
  document.addEventListener('click', function(e) {
    if (e.target.closest('.load-more_btn')) {
      custom_theme.initSoldOutSort();
    }
  });
//   document.querySelectorAll('.filter-group').forEach(function(group) {
//     group.addEventListener('click', function() {
//       setTimeout(observeProductGrid, 500); // Wait for grid to update
//     });
//   });
document.addEventListener('click', function (e) {
    const filter_input  = e.target.closest('.filter-group input');
    const filter_select  = e.target.closest('.filter-group select');
    const active_filter = e.target.closest('.collection__active__filters .active__filters__remove');
    if (filter_input || filter_select || active_filter ) {
        console.log("filter")
      setTimeout(function() {
        custom_theme.initSoldOutSort();
        }, 500);
    }
});

})();
